import parsePhoneNumberFromString, { type CountryCode, isSupportedCountry } from 'libphonenumber-js/mobile'

import { getEnv } from '@/helpers/environment'

import { configIdentityFields } from './identityHelpers'

const currencyToCountryCodeMap: Record<string, CountryCode> = {
  AUD: 'AU',
  CAD: 'CA',
  GBP: 'GB',
  NZD: 'NZ',
  USD: 'US',
}

export function getDefaultCountry(initialPhoneNumberValue = ''): CountryCode {
  if (initialPhoneNumberValue) {
    const parsedPhoneNumber = parsePhoneNumberFromString(initialPhoneNumberValue)
    if (parsedPhoneNumber?.country) {
      return parsedPhoneNumber.country
    }
  }

  const identityFormDefaultCountry = configIdentityFields().country?.default
  if (typeof identityFormDefaultCountry === 'string' && isSupportedCountry(identityFormDefaultCountry.toUpperCase())) {
    return identityFormDefaultCountry.toUpperCase() as CountryCode
  }

  // TODO: get country from venue

  return currencyToCountryCodeMap[getEnv().portal.default_currency_code] ?? 'US'
}
